/**
 * Generated bundle index. Do not edit.
 */
export { Portal, ComponentPortal, TemplatePortal, BasePortalHost, DomPortalHost, TemplatePortalDirective, PortalHostDirective, PortalModule, PortalInjector } from './public-api';
//# sourceMappingURL=index.js.map